import { useState } from "react";
import { INR, calcEMI } from "@/lib/api";

export default function EmiCalculator() {
  const [amount, setAmount] = useState(1000000);
  const [rate, setRate] = useState(10.5);
  const [months, setMonths] = useState(60);
  const emi = calcEMI(amount, rate, months);
  const total = emi * months;
  const interest = total - amount;

  return (
    <div data-testid="emi-page" className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
      <div className="sk-badge sk-badge-gold">Tools</div>
      <h1 className="mt-4 font-display text-5xl text-white leading-tight">EMI <span className="gold italic">Calculator</span></h1>
      <p className="text-white/60 mt-3 max-w-lg">Plan your loan repayment in seconds. Adjust amount, rate and tenure to see your monthly EMI.</p>

      <div className="mt-12 grid lg:grid-cols-2 gap-10">
        <div className="sk-card-dark p-8">
          <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">Loan amount</label>
          <input data-testid="emi-amount" type="range" min="10000" max="100000000" step="10000" value={amount} onChange={(e)=>setAmount(+e.target.value)} className="w-full accent-[#D4AF37]"/>
          <div className="flex justify-between text-sm mt-1"><span className="text-white/50">₹10K</span><span className="text-white font-medium">{INR(amount)}</span><span className="text-white/50">₹10Cr</span></div>

          <label className="mt-8 block text-xs uppercase tracking-widest text-white/60 mb-2">Interest rate (annual %)</label>
          <input data-testid="emi-rate" type="range" min="5" max="24" step="0.1" value={rate} onChange={(e)=>setRate(+e.target.value)} className="w-full accent-[#D4AF37]"/>
          <div className="flex justify-between text-sm mt-1"><span className="text-white/50">5%</span><span className="text-white font-medium">{rate}%</span><span className="text-white/50">24%</span></div>

          <label className="mt-8 block text-xs uppercase tracking-widest text-white/60 mb-2">Tenure (months)</label>
          <input data-testid="emi-months" type="range" min="3" max="360" step="1" value={months} onChange={(e)=>setMonths(+e.target.value)} className="w-full accent-[#D4AF37]"/>
          <div className="flex justify-between text-sm mt-1"><span className="text-white/50">3</span><span className="text-white font-medium">{months} mo ({(months/12).toFixed(1)} yr)</span><span className="text-white/50">360</span></div>
        </div>

        <div className="sk-card-dark p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Your monthly EMI</div>
          <div className="font-display text-6xl text-[#D4AF37] mt-3" data-testid="emi-value">{INR(emi)}</div>
          <div className="sk-divider my-8"/>
          <div className="grid grid-cols-2 gap-6 text-sm">
            <div><div className="text-white/50">Principal</div><div className="text-white text-xl font-medium mt-1">{INR(amount)}</div></div>
            <div><div className="text-white/50">Total interest</div><div className="text-white text-xl font-medium mt-1">{INR(interest)}</div></div>
            <div className="col-span-2"><div className="text-white/50">Total payable</div><div className="text-white text-2xl font-medium mt-1">{INR(total)}</div></div>
          </div>
          <div className="mt-8 h-3 rounded-full bg-white/5 overflow-hidden flex">
            <div className="bg-[#D4AF37]" style={{ width: `${(amount/total)*100}%` }}/>
            <div className="bg-[#8A6E1E]" style={{ width: `${(interest/total)*100}%` }}/>
          </div>
          <div className="flex justify-between mt-3 text-xs">
            <span className="text-[#D4AF37]">Principal ({((amount/total)*100).toFixed(0)}%)</span>
            <span className="text-white/60">Interest ({((interest/total)*100).toFixed(0)}%)</span>
          </div>
        </div>
      </div>
    </div>
  );
}
